import React from 'react';
import { Form } from 'react-router-dom';

function ForgotPassword() {
	return <Form></Form>;
}

export default ForgotPassword;
